import React from "react";
import { Handle, Position } from "reactflow";

const ParentNode = ({ data, isConnectable }) => {
    // const id = useNodeId();
    // const { getNodes } = useReactFlow();
    // const updateNodeInternals = useUpdateNodeInternals();
    // const nodeRef = useRef(null);

    // useEffect(() => {
    //     console.log(data);
    // },[data])

    const handleStyle = {
        backgroundColor: "black",
        width: "2px",
        height: "2px",
        borderRadius: "50%",
        border: "1px solid #ccc",
        cursor: "pointer",
        pointerEvents: "auto", // Make handles clickable
    };

    const bottomHandleStyle = {
            ...handleStyle,
            transform: "translateY(20px) translateX(-50%)"
        };

    const handleClick = (event) => {
        if (data.onClick) {
            data.onClick(event, data.id);
        }
    }

    const addBtnStyle = {
        borderRadius: "50%",
        width: "20px",
        height: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #0000FF",
        backgroundColor: "#fff",
        color: "#0000FF",
        fontSize: "10px",
        lineHeight: "1",
    };

    const onAddNextActionClick = (event) => {
        event.stopPropagation(); // Prevent the click from propagating to the node
        if (data.onAddNextActionClick) {
            data.onAddNextActionClick(event, data.id, data.parentId, data.style.height + 50);
        }
    }

    // useEffect(() => {
    //     if (nodeRef.current) {
    //         const node = getNodes().find((n) => n.id === id);
    //         if (node) {
    //             node.extent = 'parent';
    //             updateNodeInternals(id);
    //         }
    //     }
    // }, [id, getNodes, updateNodeInternals]);

    return (
        <div className="z-0 flex flex-col items-center justify-center">
            <div
                // ref={nodeRef}
                onClick={handleClick}
                draggable={true}
                className="relative rounded-md border border-gray-800 bg-gray-100 text-center text-gray-900"
                style={{
                    // position: "relative",
                    zIndex: 1, // Ensure the node is above other elements
                    // background: "transparent",
                    opacity:0.8,
                    width: data && data.style && data.style.width ? data.style.width : "100%", // Default to 100% if no width is provided
                    height: data && data.style && data.style.height ? data.style.height : "100%", // Default to 100% if no height is provided
                    // paddingBottom: "50px", // Ensure there's space for the add button
                }}
            >
                <Handle
                    type="target"
                    position={Position.Top}
                    id="a"
                    isConnectable={isConnectable}
                    style={handleStyle}
                />
                <Handle
                    type="source"
                    position={Position.Bottom}
                    id="b"
                    isConnectable={isConnectable}
                    style={bottomHandleStyle}
                />
                <div
                    title={data.label}
                    className="overflow-hidden text-ellipsis whitespace-nowrap text-[0.5rem]"
                // style={{ pointerEvents: "none" }} // Prevent clicks on child elements
                >
                    {data.label}
                </div>
            </div><div onClick={onAddNextActionClick} style={addBtnStyle}>+</div>
        </div>
    );
};

export default ParentNode;
